import { Injectable } from '@angular/core';
import { CompanyDto, ConfirmResponse, UpdateCompanyRequest } from '@app/models';
import { CreateCompanyUserRequest, UserDto } from '@app/models/user.model';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CompanyApi extends ApiService {
  static userPrefix = '/user';
  static companyPrefix = '/company';

  public getUsers(): Observable<UserDto[]> {
    return this.get(`${CompanyApi.userPrefix}/list`, true);
  }

  public createUser$(user: CreateCompanyUserRequest): Observable<UserDto> {
    return this.post(CompanyApi.userPrefix, user);
  }

  public updateUser$(
    id: number,
    user: CreateCompanyUserRequest,
  ): Observable<UserDto> {
    return this.put(`${CompanyApi.userPrefix}/${id}`, user);
  }

  public removeUser$(id: number): Observable<ConfirmResponse> {
    return this.delete(`${CompanyApi.userPrefix}/${id}`);
  }

  public getCompanyDetails$(): Observable<CompanyDto> {
    return this.get(`${CompanyApi.companyPrefix}`);
  }

  public updateCompany$(company: UpdateCompanyRequest): Observable<CompanyDto> {
    return this.put(`${CompanyApi.companyPrefix}/${company.id}`, company);
  }
}
